import { FC } from 'react'
import { CmsQuestion } from '../index'
import styles from './styles.module.scss'
import { Button, ButtonVariants } from '../../Button'

export interface QuestionProps {
  data: CmsQuestion
  selectionHandler: (index: number) => void
}

export const Question: FC<QuestionProps> = ({ data, selectionHandler }) => {
  return (
    <div className={styles.question}>
      <h5 className={styles.title}>{data.title}</h5>
      {data.options.map((option, index) => {
        return (
          <div className={styles.optionList} key={index}>
            <Button
              onClick={() => selectionHandler(index)}
              variant={ButtonVariants.TERTIARY}
            >
              {option.fields.title}
            </Button>
          </div>
        )
      })}
    </div>
  )
}
